import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router';
import { resolveOrganisationKind } from '@/queries/organisationKinds';

export const ORGANISATION_PATH = '/organisations/:kind(partner|customer)/:id';
// The id pattern keeps it off `/organisations/partner/…`.
export const LEGACY_ORGANISATION_PATH =
  '/organisations/:id([0-9A-Z]{26})/:rest(.*)*';

/** Sends a link without the kind (`/organisations/:id/…`, `/view/…` included) to the same tab under its kind. */
export async function redirectLegacyOrganisationRoute(
  to: RouteLocationNormalized
): Promise<RouteLocationRaw> {
  const id = String(to.params.id);
  const rest = [to.params.rest ?? []].flat().filter(Boolean).map(String);
  if (rest[0] === 'view') rest.shift();

  try {
    const kind = await resolveOrganisationKind(id);
    return {
      path: ['/organisations', kind, id, ...rest].join('/'),
      query: to.query,
      hash: to.hash,
      replace: true,
    };
  } catch {
    return { name: 'organisations', replace: true };
  }
}
